import React, { useRef, useState } from 'react';
import { useWatch, useController } from 'react-hook-form';
import classNames from 'classnames';
import TooltipButton from '../../../TooltipButton/TooltipButton';
import styles from './DeviceChartXAxis.module.css';

function DeviceChartXAxis({ editable, scales }) {
  const defaultTitle = scales.x?.title?.text || 'Time';
  const [inputVisible, setInputVisible] = useState(false);
  const [tooltipVisible, setTooltipVisible] = useState(false);

  const handleMouseEnter = () => {
    setTooltipVisible(true);
  };
  const handleMouseLeave = () => {
    setTooltipVisible(false);
  };

  const handleClick = () => {
    setTooltipVisible(false);
    setInputVisible(true);
  };

  const handleClose = () => {
    setInputVisible(false);
  };

  return (
    <div className={styles.root}>
      {inputVisible ? (
        <TitleEditor axisId="x" defaultValue={defaultTitle} onClose={handleClose} />
      ) : (
        <div
          className={styles.title}
          onMouseEnter={editable ? handleMouseEnter : undefined}
          onMouseLeave={editable ? handleMouseLeave : undefined}
        >
          <div
            className={classNames(styles.titleText, { [styles.titleTextEditable]: editable })}
            onClick={editable ? handleClick : undefined}
          >
            {defaultTitle}
          </div>
        </div>
      )}
      <div className={styles.titleTooltip}>{editable && tooltipVisible && <TooltipButton disabled />}</div>
    </div>
  );
}

export default DeviceChartXAxis;

function TitleEditor({ axisId, defaultValue, onClose }) {
  const inputRef = useRef(null);
  const scales = useWatch({ name: 'state.scales' });
  const index = scales.findIndex((scale) => scale.key === axisId);
  const {
    field: { value, onChange }
  } = useController({ name: `state.scales.${index}.label`, defaultValue });

  const handleBlur = () => {
    onChange(inputRef.current.value);
    onClose();
  };

  return <input ref={inputRef} className={styles.titleInput} autoFocus onBlur={handleBlur} defaultValue={value} />;
}
